import { InputFieldsReducer } from './reducer'
import { makeContext } from '../createDataContext'
import actions from './action'

export default makeContext(InputFieldsReducer,actions)